<!--
 * @Author: your name
 * @Date: 2020-05-24 21:58:17
 * @LastEditTime: 2020-06-28 10:36:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\website\src\views\Homepage.vue
-->


<template>
  <div class="yqh_homepage">
    <div class="homepage_content">
      <!-- 轮播图 -->
      <div class="homepage_banner">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/banner.jpg" class="bannerImg" />
      </div>
      <!-- <div class="homepage_banner" v-if="imgList">
          <img :src="imgList[0].img_url" class="bannerImg" />
      </div>
      <div class="homepage_banner" v-else>
        <el-carousel :interval="3000" arrow="always" autoplay indicator-position="none">
          <el-carousel-item v-for="(img,index) in imgList " :key="index">
            <img :src="img.img_url" />
          </el-carousel-item>
        </el-carousel>
      </div> -->
      
      <!-- 轮播图 end-->
      <!-- 自由薪 -->
      <div class="salary_content">
        <div class="salary_left">
          <div class="salaryleft_title">自由职业者众包</div>
          <p class="salaryleft_word">为共享经济平台和自由职业者两端提供结算即报税、 缴税、开票三合</p>
          <p class="salaryleft_word">一体的AI智慧完税支付服务，帮助全国范围内的共享经济和灵活</p>
          <p class="salaryleft_word">用工态企业降低运营成本、提高运营效率、实现合规经营，助力</p>
          <p class="salaryleft_word">企业发展！</p>
          <div class="button" @click="salary">
            <el-row>
              <el-button type="primary">查看详情</el-button>
            </el-row>
          </div>
        </div>
        <div class="salary_img">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/illustration_1.gif" class="image" />
        </div>
      </div>
      <!-- 自由薪 end-->
      <!-- 合伙人 -->
      <div class="partner_content">
        <div class="partner_img">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/illustration_2.gif" class="image" />
        </div>
        <div class="partner_right">
          <div class="partner_title">个体工商户注册</div>
          <p class="partner_word">云企惠零售财税平台将企业及合伙人经营的资金、财税、票据</p>
          <p class="partner_word">和人事打通，为合伙人提供财票税服务的同时，实现</p>
          <p class="partner_word">财票税管理的数字化提升。核心包括合伙人财票税管理、电子</p>
          <p class="partner_word">凭证数据票仓和共享财务服务中心，配合企业实现真正意义上</p>
          <p class="partner_word">的智慧零售。</p>
          <div class="button" @click="partner">
            <el-row>
              <el-button type="primary">查看详情</el-button>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 合伙人 end-->
      <!-- 我们的优势 -->
      <div class="advantages_content">
        <div class="advantages">
          <div class="title">我们的优势</div>
          <div class="solve">
            <div class="solve_card">
              <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/card1.png" />
            </div>
            <div class="solve_card">
              <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/card2.png" />
            </div>
            <div class="solve_card">
              <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/card3.png" />
            </div>
            <div class="solve_card">
              <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/card4.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 我们的优势 end-->
      <!-- 合作商 -->
      <div class="company_content">
        <div class="company">
          <div class="company_title">云企惠正在为各行各业提供解决方案</div>
          <div class="company_logo">
            <el-row :gutter="20">
              <el-col :span="6" style="padding-left: 0px; padding-right: 0px;">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyOne.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyTwo.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyThree.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyFour.png" />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6" style="padding-left: 0px; padding-right: 0px;">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyFive.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companySix.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companySevent.png" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/homepage/companyEight.png" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 合作商 end-->
      <!-- 底部栏 -->
      <Footer></Footer>
      <!-- 底部栏 end-->
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?4e8aeccd1dca0a0c25892ce25cc71530";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();
export default {
  data() {
    return {
      // imgList: [],
    };
  },
  components: {
    Footer
  },
  methods: {
    salary() {
      this.$router.push("/FreeSalary");
    },
    partner() {
      this.$router.push("/Partner");
    },
    //获取轮播图
    // getBannerList() {
    //   let that = this;
    //   let map = {};
    //   that.$http
    //     .post("website/getBannerList")
    //     .then(function(res) {
    //       console.log(res.data.data)
    //       let dataImg = res.data.data;
    //       // .el-carousel__arrow
    //       var obj1 = document.getElementsByClassName('el-carousel__arrow')
    //       // console.log(obj1)
    //       // if( dataImg.length <= 1 ){
            
    //       // }
    //       localStorage.setItem('dataImg',JSON.stringify(dataImg));
    //     })
    //     .catch(function(e) {
    //       console.log(e);
    //     });
    // }
  },
  created() {
    // this.getBannerList();
    // this.imgList = JSON.parse(localStorage.getItem('dataImg'));
  }
};
</script>
<style lang="less">
// body {
//   margin: 0;
//   padding: 0;
// }
.yqh_homepage {
  width: 100%;
  position: relative;
  .bannerImg{
    width: 100%;
  }
  .homepage_content {
    width: 100%;
    height: 100%;
    .homepage_banner {
      width: 100%;
      .el-carousel--horizontal {
        width: 100%;
        .el-carousel__container {
          width: 100%;
          height: 750px;
          // max-height: 100%;
          img {
            width: 100%;
            // max-height: 100%;
            object-fit: cover;
            height: 750px;
          }
          .el-carousel__arrow {
            background-color: rgba(57, 78, 102, 0.616);
            width: 60px;
            height: 60px;
          }
          .el-carousel__arrow--left {
            left: 70px;
          }
          .el-carousel__arrow--right {
            right: 70px;
          }
          .el-icon-arrow-left:before {
            font-size: 20/16rem;
          }
          .el-icon-arrow-right:before {
            font-size: 20/16rem;
          }
        }
      }
    }
    .salary_content {
      width: 1140px;
      margin: 0 auto;
      margin-top: 100px;

      overflow: hidden;
      .salary_left {
        float: left;
        width: 50%;
        .salaryleft_title {
          text-align: center;
          font-size: 32px;
          color: #333333;
          font-weight: 700;
          letter-spacing: 1px;
          margin-bottom: 14px;
        }
        .salaryleft_word {
          text-align: center;
          line-height: 30px;
          color: #999999;
          font-size: 16px;
          // font-family: AlbbRegular;
        }
        .button {
          text-align: center;
          margin-top: 32px;

          .el-button--primary {
            border: none;
            border-radius: 6px;
            font-size: 14px;
            background-color: var(--themeColor);
          }
        }
      }
      .salary_img {
        float: right;
        width: 40%;

        .image {
          width: 300px;
          height: 300px;
          background-size: 100% auto;
        }
      }
    }
    .partner_content {
      width: 1140px;
      margin: 0 auto;
      margin-top: 80px;
      overflow: hidden;
      margin-bottom: 74px;
      .partner_img {
        float: left;
        width: 40%;
        .image {
          width: 424px;
          height: 424px;
          background-size: 100% auto;
        }
      }
      .partner_right {
        float: right;
        width: 50%;
        margin-top: 50px;
        .partner_title {
          text-align: center;
          color: #333333;
          font-weight: 700;
          letter-spacing: 1px;
          font-size: 32px;

          margin-bottom: 14px;
        }
        .partner_word {
          text-align: center;
          line-height: 30px;
          color: #999999;
          font-size: 16px;
          // font-family: AlbbRegular;
        }
        .button {
          text-align: center;
          margin-top: 32px;
          .el-button--primary {
            border: none;
            border-radius: 6px;
            font-size: 14px;
            background-color: var(--themeColor);
          }
        }
      }
    }
    .advantages_content {
      width: 100%;
      background-color: rgba(219, 228, 238, 0.226);
      padding-bottom: 100px;
      box-sizing: border-box;
      .advantages {
        width: 1140px;
        margin: 0 auto;
        .title {
          padding-top: 80px;
          margin-bottom: 100px;
          font-size: 32px;
          text-align: center;
          color: #333333;
          font-weight: 700;
          letter-spacing: 1px;
        }
        .solve {
          width: 100%;
          display: flex;
          cursor: pointer;
          padding-bottom: 100px;
          box-sizing: border-box;
          // margin: 0 auto;
          margin-left: 20px;

          .solve_card {
            width: 100%;
            position: relative;
            top: 0;
            left: 0;
            overflow: hidden;
            img {
              max-width: 100%;
            }
          }
        }
      }
    }
    .company_content {
      width: 100%;
      .company {
        width: 1140px;
        margin: 0 auto;
        padding-bottom: 120px;
        .company_title {
          text-align: center;
          color: #333333;
          font-weight: 700;
          letter-spacing: 1px;
          font-size: 32px;
          margin-top: 78px;
        }
        .company_logo {
          margin-top: 80px;
          text-align: center;
          .el-row {
            margin-bottom: 30px;
          }
          img {
            width: 198px;
            // height: 176px;
            transform: scale(0.7);
          }
        }
      }
    }
  }
}
</style>
